import React, { Component } from "react";
import Alert from "sweetalert-react";
import { Modal, Button } from "react-bootstrap";
import { DocumentViewer } from "../../Shared";
import ResumeTable from "./ResumeTable";
import { FileUpload } from "../Styles/Platform.style";
import { Header, HeaderTitle, Row } from "./Styles/Resume.styles";

export default class Resumes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      showDocumentViewer: false,
      openModal: false,
      files: null,
    };
  }

  showDocument = (url) => {
    this.setState({
      showDocumentViewer: true,
      documentUrl: url,
    });
  };

  openModal = () => {
    this.setState({ openModal: true });
  };

  uploadSuccess = () => {
    const { add } = this.props;
    const { files } = this.state;
    add(files);
    this.setState({ openModal: false });
  };

  cancelUpload = () => {
    this.setState({ openModal: false });
  };

  hideDocument = () => {
    this.setState({ showDocumentViewer: false });
  };

  handleChange = (event) => {
    const { files } = event.target;
    this.setState({ files });
  };

  confirm = (resume) => {
    this.setState({ show: true, resume });
  };

  remove = () => {
    const { remove } = this.props;
    const { resume } = this.state;
    remove(resume);
    this.setState({ show: false });
  };

  render() {
    const {
      openModal,
      files,
      show,
      showDocumentViewer,
      documentUrl,
    } = this.state;
    const { resumes } = this.props;
    return (
      <div className="TabbedPanelsContent">
        <Header>
          <HeaderTitle>Resumes</HeaderTitle>
          <label
            onClick={this.openModal}
            className="btn btn-primary btn_apply white_bg"
            style={{ float: "right", cursor: "pointer"}}
          >
            New Resume
          </label>
          {openModal && (
            <div className="static-modal">
              <Modal.Dialog>
                <Modal.Header>
                  <Modal.Title>Upload Your Resume</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <Row>
                    <div className="col">
                      <FileUpload>
                        Upload Resume
                        <input
                          type="file"
                          id="resume"
                          name="resume"
                          aria-hidden="true"
                          onChange={this.handleChange}
                        />
                      </FileUpload>
                    </div>
                    <div className="col">{files && files[0].name}</div>
                  </Row>
                </Modal.Body>

                <Modal.Footer>
                  <Button onClick={this.uploadSuccess}>OK</Button>
                  <Button onClick={this.cancelUpload}>Cancel</Button>
                </Modal.Footer>
              </Modal.Dialog>
            </div>
          )}
        </Header>
        <div className="tab_padd recent_job">
          <div className="scrobl_div post">
            {resumes.length > 0 ? (
              <ResumeTable
                {...this.props}
                confirm={this.confirm}
                remove={this.remove}
                showDocument={this.showDocument}
              />
            ) : (
              <div style={{ padding: 20, paddingTop: 100 }}>
                You have no resumes saved. Click
                <label
                  onClick={this.openModal}
                  style={{
                    textDecoration: "underline",
                    color: "#499",
                    cursor: "pointer",
                  }}
                >
                  here
                </label>
                to upload a resume!
              </div>
            )}
          </div>
        </div>
        <Alert
          show={show}
          title="Are you sure?"
          text="Once deleted, you will not be able to recover this resume file!"
          type="warning"
          showCancelButton
          buttons
          dangerMode
          onConfirm={this.remove}
          onCancel={() => {
            this.setState({ show: false });
          }}
        />
        <DocumentViewer
          show={showDocumentViewer}
          url={documentUrl}
          hide={this.hideDocument}
        />
      </div>
    );
  }
}
